(() => {
  const sentVitals = new Set();
  const vitals = { cls: 0, inp: 0, lcp: 0 };
  const defaultReorderSource = 'storefront';
  window.H7PerformanceVitals = vitals;
  const syncVitals = () => {
    document.documentElement.dataset.h7VitalsLcp = String(vitals.lcp);
    document.documentElement.dataset.h7VitalsCls = vitals.cls.toFixed(4);
    document.documentElement.dataset.h7VitalsInp = String(vitals.inp);
  };
  syncVitals();

  const analyticsAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return typeof privacy?.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed();
  };

  const track = (eventName, detail = {}) => {
    if (!analyticsAllowed()) return;
    const payload = {
      event: `h7_${eventName}`,
      page_type: window.meta?.page?.pageType || document.body?.dataset?.template || '',
      path: window.location.pathname,
      ...detail,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('h7:analytics', { detail: payload }));

    try {
      window.Shopify?.analytics?.publish?.(`h7_${eventName}`, payload);
    } catch (_error) {
      // Analytics bridge availability varies by storefront context.
    }
  };

  window.H7Analytics = { track };

  document.addEventListener('click', (event) => {
    const tracked = event.target.closest('[data-h7-track]');
    if (tracked) track(tracked.dataset.h7Track, { label: tracked.textContent.trim().slice(0, 120) });

    const checkout = event.target.closest('[name="checkout"], [href*="/checkout"]');
    if (checkout) track('cart_to_checkout', { source: checkout.closest('cart-drawer') ? 'cart_drawer' : 'page' });

    const reorder = event.target.closest('[data-h7-reorder]');
    if (reorder) track('reorder', { source: reorder.dataset.h7Reorder || defaultReorderSource });
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target.closest?.('[data-h7-track-accordion]');
      if (details?.open) track('accordion_open', { accordion: details.dataset.h7TrackAccordion });
    },
    true
  );

  // Guarded like every other storage access in the theme: with all cookies
  // blocked the getter throws and would kill the vitals observers below.
  try {
    const orderId = window.Shopify?.checkout?.order_id;
    if (orderId && sessionStorage.getItem(`h7_purchase_${orderId}`) !== 'sent') {
      track('purchase', {
        order_id: orderId,
        total: window.Shopify.checkout.total_price,
        currency: window.Shopify.checkout.currency,
      });
      sessionStorage.setItem(`h7_purchase_${orderId}`, 'sent');
    }
  } catch (error) {
    // Purchase tracking simply skips when storage is unavailable.
  }

  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const last = entries[entries.length - 1];
        if (last) {
          vitals.lcp = Math.round(last.startTime);
          syncVitals();
        }
      }).observe({ type: 'largest-contentful-paint', buffered: true });

      new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (!entry.hadRecentInput) {
            vitals.cls += entry.value;
            syncVitals();
          }
        });
      }).observe({ type: 'layout-shift', buffered: true });

      new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const duration = entry.duration || 0;
          if (duration > vitals.inp) {
            vitals.inp = Math.round(duration);
            syncVitals();
          }
        });
      }).observe({ type: 'event', buffered: true, durationThreshold: 16 });
    } catch (_error) {
      // Older browsers can omit one or more observer entry types.
    }
  }

  const sendVitals = () => {
    if (sentVitals.has(window.location.pathname)) return;
    sentVitals.add(window.location.pathname);
    track('web_vitals', {
      lcp_ms: vitals.lcp,
      cls: Number(vitals.cls.toFixed(4)),
      inp_ms: vitals.inp,
    });
  };

  window.addEventListener('pagehide', sendVitals, { once: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') sendVitals();
  });
})();
